/* eslint-disable */
import { on, off, getComputedStyle } from './dom';
import debounce from './debounce';

const POSITION_MAP = {
    bottom(el, currentTop, offset) {
        const styles = getComputedStyle(el);
        const borderTop = parseInt(styles.borderTopWidth, 10);
        const borderBottom = parseInt(styles.borderBottomWidth, 10);
        const targetTop = el.scrollHeight - (el.offsetHeight - borderTop - borderBottom);
        return currentTop > 0 && currentTop + offset >= targetTop;
    },
    top(el, currentTop, offset) {
        return currentTop <= offset;
    }
};

const calcPostion = debounce(function(el, binding) {
    if (typeof binding.value !== 'function') {
        return;
    }

    Object.keys(binding.modifiers).forEach((mod, index) => {
        if (!POSITION_MAP[mod]) {
            binding.offset = mod;
            return;
        }

        const currentTop = el.scrollTop;
        const result = POSITION_MAP[mod](el, currentTop, parseInt(binding.offset, 10) || 0);
        if (result) {
            binding.value(mod, currentTop);
        }
    });
}, 200);

const HOOK_PROPNAME = 'VHTML_ON_SCROLLTO_DIRECTIVE';

export default {
    name: 'on-scrollto',

    bind(el, binding, vnode) {
        const onscroll = function() {
            calcPostion(el, binding);
        };
        on(el, 'scroll', onscroll);

        Object.defineProperty(el, HOOK_PROPNAME, {
            value: onscroll,
            configurable: true,
            enumerable: false
        });
    },

    unbind(el) {
        const onscroll = el[HOOK_PROPNAME];
        off(el, 'scroll', onscroll);
    }
};
